import { render, staticRenderFns } from "./LongtextQuestion.vue?vue&type=template&id=26152190&"
import script from "./LongtextQuestion.vue?vue&type=script&lang=js&"
export * from "./LongtextQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports